import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import urlMapping from '../app/URLMapping';
import {MiniPanel} from './EmbededPanel.react';
import EventTracker from '../app/EventTracker';

class MinifiedPanel extends React.Component {

    static propTypes = {
        user: PropTypes.object.isRequired,
    };

    static contextTypes = {
        embededPanelController: PropTypes.object,
        router: PropTypes.object,
    };

    constructor(props) {
        super(props);

        EventTracker.initEventTracker(props.user);
    }

    config = () => {
        this.context.embededPanelController.cancelMinimizePanel();

        let path = urlMapping.getUrl("panel", "screen-settings", this.context.embededPanelController.getURLObject());
        this.context.router.push(path);
    };

    restore = () => {
        this.context.embededPanelController.cancelMinimizePanel();

        let path = urlMapping.getUrl("panel", "panel", this.context.embededPanelController.getURLObject());
        console.log("Development Panel URL", {path: path});  // eslint-disable-line no-console
        this.context.router.push(path);
    };

    render() {
        return (
            <MiniPanel
                config={this.config}
                restore={this.restore}
                typeForTest="minified"
            />
        );
    }
}

export default Relay.createContainer(MinifiedPanel, {
    initialVariables: {
    },
    prepareVariables (variables) {
        return variables;
    },
    fragments: {
        user: () => {
            return Relay.QL`
                fragment on User {
                    id,
                    realId,
                    ${EventTracker.getFragment()},
                }`;
        }
    },


});
